import { getItemCustomSelect, getListItemCustomSelect, getSharePointSite } from "../src/taskpane/services/GraphService";
import authModule from "./AuthModule";

export interface IContainerDisplayNames {
    siteDisplayName: string;
    libraryDisplayName: string;
}

export const getContainerDisplayNames = async (driveId: string, itemId: string): Promise<IContainerDisplayNames> => {
    const [siteDisplayName, libraryDisplayName] = await Promise.all([
        (async () => {
            const siteId: string = (await getListItemCustomSelect(driveId, itemId, "parentReference"))?.parentReference?.siteId;
            if (siteId) {
                return (await getSharePointSite(siteId))?.name;
            }
            return null;
        })(),
        (async () => {
            return (await getItemCustomSelect(await authModule.getGraphAccessToken(), driveId, null, "name"))?.name;
        })()
    ]);

    return { siteDisplayName, libraryDisplayName };
}